import React, { useEffect, useState } from 'react';

import TableCell from '@mui/material/TableCell';
import Button from '@mui/material/Button';
import TableRow from '@mui/material/TableRow';
import Dialog from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';
import FormHelperText from '@mui/material/FormHelperText';
import { IProductSchema } from '../../../../../../graphql/type/product';
import FormUpdateProductInventory from './FormUpdateProductInventory';

interface IProps {
  item: IProductSchema['variations'][0];
  onChange: (item: IProductSchema['variations'][0]) => void;
  refreshKey?: number;
}

export default function ProductVariationInventoryTableItem(props: IProps) {
  const { item, onChange, refreshKey } = props;
  const { t } = useTranslation();
  const [isOpenUpdateDialog, setIsOpenUpdateDialog] = useState(false);
  const [initialItem, setInitialItem] = useState(item);
  const attributes = item.attributes ? item.attributes : {};
  if (!attributes.sku) return null;

  useEffect(() => {
    setInitialItem(item);
  }, [refreshKey]);

  return (
    <TableRow>
      <Dialog
        open={isOpenUpdateDialog}
        onClose={() => setIsOpenUpdateDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <FormUpdateProductInventory
          item={item}
          onChange={onChange}
          onCancel={() => {
            setIsOpenUpdateDialog(false);
          }}
        />
      </Dialog>
      <TableCell>
        <Button
          color="primary"
          onClick={() => {
            setIsOpenUpdateDialog(true);
          }}
        >
          {attributes.sku}
          {JSON.stringify(initialItem) !== JSON.stringify(item) && (
            <FormHelperText error>&nbsp;{t('unsaved_changes')}</FormHelperText>
          )}
        </Button>
      </TableCell>
    </TableRow>
  );
}
